export default function calculatePlannedAmount(amount: number, probabilityPercentage?: number) {
    const probability = (undefined === probabilityPercentage ? 100 : probabilityPercentage) / 100;
    return amount * probability;
}
